import { Component } from "@angular/core";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: "app-loading-spinner",
  templateUrl: "./loading-spinner.html",
  standalone: true,
  imports: [MatProgressSpinner]
})
export class LoadingSpinnerComponent {}
